import {FC} from 'react'
import {PaginationProps} from './types'
import {FormattedMessage} from 'react-intl'
import ReactPaginate from 'react-paginate'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'

const Pagination: FC<PaginationProps> = ({
  totalPages = 0,
  pageSize = 10,
  currentPage = 1,
  totalRecords = 1,
  onPageChange,
}) => {
  const generalSettings = useSelector<RootState>(
    ({mainReducer}) => mainReducer.generalSettings
  ) as any

  const pageSizesSet = new Set<number>([10, 20, 50, 100, 500, 1000])

  if (generalSettings?.default_page_size && !pageSizesSet.has(generalSettings?.default_page_size)) {
    pageSizesSet.add(generalSettings?.default_page_size)
  }

  const pageSizes = Array.from(pageSizesSet).sort((a, b) => a - b)

  return (
    <div className='row gy-10 w-100'>
      <div className='col-md-7 col-xxl-9 d-flex align-items-center justify-content-center justify-content-md-start'>
        <div id='kt_table_users_paginate'>
          <ReactPaginate
            containerClassName='pagination'
            pageClassName='page-item'
            pageLinkClassName='page-link'
            activeClassName='active'
            nextClassName='page-item'
            nextLinkClassName='page-link'
            previousClassName='page-item'
            previousLinkClassName='page-link'
            breakClassName='page-item'
            breakLinkClassName='page-link'
            previousLabel='<'
            nextLabel='>'
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            pageCount={totalPages}
            forcePage={currentPage - 1}
            onPageChange={(page) => onPageChange(page.selected + 1, pageSize)}
          />
        </div>
      </div>

      <div className='col-4 col-md-2 col-xxl-1'>
        <select
          className='form-select form-select-sm form-select-solid'
          defaultValue={pageSize}
          onChange={(e: any) => onPageChange(currentPage, e.target.value)}
        >
          <option value='' disabled>
            Select Page Size
          </option>
          {pageSizes.map((size, idx) => (
            <option value={size} key={idx}>
              {size}
            </option>
          ))}
        </select>
        {/* <span className='fs-6 fw-bold text-gray-700'>Showing 1 to 10 of 50 entries</span> */}
      </div>

      <div className='col-8 col-md-3 col-xxl-2 pt-2 fs-6 fw-bold text-gray-700 text-center'>
        <FormattedMessage
          id='GENERAL.GRID_SHOWING_TOTAL'
          values={{
            x: pageSize * currentPage - pageSize + 1,
            y: totalRecords < pageSize * currentPage ? totalRecords : pageSize * currentPage,
            total: totalRecords,
          }}
        />
      </div>
    </div>
  )
}

export {Pagination}
